import React, { useState } from 'react';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { toast } from 'react-toastify';
import { Link, useNavigate} from 'react-router-dom';

const AddCategory = ({ onSuccess }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleAddCategory = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setError('Category name is required.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await DataService.addCategory({ name });
      setName('');
     setLoading(false);
     toast.success('Category added Successfully.');
     navigate('/categories')
      setError('');
    } catch (err) {
      setError('Failed to add category.');
    } finally {
      setLoading(false);
    }
  };
const goBack = () => navigate(-1); // navigate back to previous page

  return (
    <>
     <LoaderOverlay loading={loading} />
   

     

      <h4>Add New Category</h4>

      <form onSubmit={handleAddCategory} className="mt-3">
        <div className="mb-3">
          <label className="form-label">Category Name</label>
          <input
            type="text"
            className="form-control  px-3"
            placeholder="Enter category name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <button type="submit" className="btn btn-primary">
          Add Category
        </button>
        <button className="btn btn-outline-secondary" style={{marginLeft:'15px'}} onClick={() => navigate(-1)}>
    ← Back
  </button>
      </form>

      

     </>
  );
};

export default AddCategory;
